module.exports = __webpack_public_path__ + "img/processing-12.78886f6c.gif";